// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CampaignEffectMeasure-module__wrapper___Je7FZ {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    height: calc(100vh - 225px);
    margin-top: 8rem;
    position: relative;
}

.CampaignEffectMeasure-module__pdfArea___ZbYCk {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    width: 100%;
}

.CampaignEffectMeasure-module__pdfContainer___uPf8M {
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

.CampaignEffectMeasure-module__pageInfo___aIofU {
    font-weight: 500;
    margin-top: 1rem;
    z-index: 2;
}

.CampaignEffectMeasure-module__toolbar___aI1Ec {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 1rem auto;
}

.CampaignEffectMeasure-module__downloadContainer___WLIbi {
    margin-top: 1rem;
}

.CampaignEffectMeasure-module__sideButton____AHER {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    background-color: var(--bmo-primary-color-mint);
    color: white;
    padding: 12px 16px;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    z-index: 1;
    transition: background-color 0.3s ease;
}

    .CampaignEffectMeasure-module__sideButton____AHER:hover {
        background-color: var(--bmo-primary-color-mint-dark);
    }

    .CampaignEffectMeasure-module__sideButton____AHER:disabled {
        background-color: #ccc;
        cursor: not-allowed;
    }

.CampaignEffectMeasure-module__leftButton___D9vC2 {
    left: 5%;
}

.CampaignEffectMeasure-module__rightButton___DuswK {
    right: 5%;
}

.CampaignEffectMeasure-module__pageInfo___aIofU {
    font-weight: 500;
}

.CampaignEffectMeasure-module__loading___MthT6,
.CampaignEffectMeasure-module__error___I6T6g {
    text-align: center;
    padding: 2rem;
    color: #555;
}
`, "",{"version":3,"sources":["webpack://./app/components/ProofOfDeliveryLayout/CampaignEffectMeasure/CampaignEffectMeasure.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;IACX,2BAA2B;IAC3B,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,OAAO;IACP,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,uCAAuC;AAC3C;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,2BAA2B;IAC3B,+CAA+C;IAC/C,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,UAAU;IACV,sCAAsC;AAC1C;;IAEI;QACI,oDAAoD;IACxD;;IAEA;QACI,sBAAsB;QACtB,mBAAmB;IACvB;;AAEJ;IACI,QAAQ;AACZ;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,gBAAgB;AACpB;;AAEA;;IAEI,kBAAkB;IAClB,aAAa;IACb,WAAW;AACf","sourcesContent":[".wrapper {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    width: 100%;\n    height: calc(100vh - 225px);\n    margin-top: 8rem;\n    position: relative;\n}\n\n.pdfArea {\n    flex: 1;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    position: relative;\n    width: 100%;\n}\n\n.pdfContainer {\n    background-color: #fff;\n    border-radius: 8px;\n    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n}\n\n.pageInfo {\n    font-weight: 500;\n    margin-top: 1rem;\n    z-index: 2;\n}\n\n.toolbar {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin: 1rem auto;\n}\n\n.downloadContainer {\n    margin-top: 1rem;\n}\n\n.sideButton {\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n    background-color: var(--bmo-primary-color-mint);\n    color: white;\n    padding: 12px 16px;\n    border: none;\n    border-radius: 8px;\n    cursor: pointer;\n    z-index: 1;\n    transition: background-color 0.3s ease;\n}\n\n    .sideButton:hover {\n        background-color: var(--bmo-primary-color-mint-dark);\n    }\n\n    .sideButton:disabled {\n        background-color: #ccc;\n        cursor: not-allowed;\n    }\n\n.leftButton {\n    left: 5%;\n}\n\n.rightButton {\n    right: 5%;\n}\n\n.pageInfo {\n    font-weight: 500;\n}\n\n.loading,\n.error {\n    text-align: center;\n    padding: 2rem;\n    color: #555;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `CampaignEffectMeasure-module__wrapper___Je7FZ`,
	"pdfArea": `CampaignEffectMeasure-module__pdfArea___ZbYCk`,
	"pdfContainer": `CampaignEffectMeasure-module__pdfContainer___uPf8M`,
	"pageInfo": `CampaignEffectMeasure-module__pageInfo___aIofU`,
	"toolbar": `CampaignEffectMeasure-module__toolbar___aI1Ec`,
	"downloadContainer": `CampaignEffectMeasure-module__downloadContainer___WLIbi`,
	"sideButton": `CampaignEffectMeasure-module__sideButton____AHER`,
	"leftButton": `CampaignEffectMeasure-module__leftButton___D9vC2`,
	"rightButton": `CampaignEffectMeasure-module__rightButton___DuswK`,
	"loading": `CampaignEffectMeasure-module__loading___MthT6`,
	"error": `CampaignEffectMeasure-module__error___I6T6g`
};
export default ___CSS_LOADER_EXPORT___;
